import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function Precos() {
  const [tipos, setTipos] = useState([]);
  const [form, setForm] = useState({ registro: '', documentos: '', valor: '' });
  const [editando, setEditando] = useState(null);
  const [mostrarForm, setMostrarForm] = useState(false);

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const res = await api.get('/precos/');
    setTipos(res.data);
  }

  async function salvar() {
    const dados = { ...form, valor: parseInt(form.valor) };
    if (editando) {
      await api.put(`/precos/${editando}`, dados);
    } else {
      await api.post('/precos/', dados);
    }
    setForm({ registro: '', documentos: '', valor: '' });
    setEditando(null);
    setMostrarForm(false);
    carregar();
  }

  function editar(tipo) {
    setForm({ registro: tipo.registro, documentos: tipo.documentos || '', valor: tipo.valor });
    setEditando(tipo.id);
    setMostrarForm(true);
  }

  async function desativar(id) {
    if (window.confirm('Desativar este tipo de ato?')) {
      await api.delete(`/precos/${id}`);
      carregar();
    }
  }

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Tabela de Preços</h1>
          <button style={styles.botaoNovo} onClick={() => { setMostrarForm(true); setEditando(null); setForm({ registro: '', documentos: '', valor: '' }); }}>
            + Novo Tipo de Ato
          </button>
        </div>

        {mostrarForm && (
          <div style={styles.form}>
            <h3 style={styles.formTitulo}>{editando ? 'Editar Tipo de Ato' : 'Novo Tipo de Ato'}</h3>
            <div style={styles.grid}>
              <div style={styles.campo}>
                <label style={styles.label}>Registro *</label>
                <input style={styles.input} value={form.registro} onChange={e => setForm({ ...form, registro: e.target.value })} />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Valor (R$) *</label>
                <input style={styles.input} type="number" value={form.valor} onChange={e => setForm({ ...form, valor: e.target.value })} />
              </div>
              <div style={{ ...styles.campo, gridColumn: 'span 2' }}>
                <label style={styles.label}>Documentos necessários</label>
                <textarea style={{ ...styles.input, height: '70px' }} value={form.documentos} onChange={e => setForm({ ...form, documentos: e.target.value })} />
              </div>
            </div>
            <div style={styles.formBotoes}>
              <button style={styles.botaoSalvar} onClick={salvar}>Salvar</button>
              <button style={styles.botaoCancelar} onClick={() => setMostrarForm(false)}>Cancelar</button>
            </div>
          </div>
        )}

        <table style={styles.tabela}>
          <thead>
            <tr>
              {['Registro', 'Documentos', 'Valor', 'Ações'].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tipos.map(t => (
              <tr key={t.id} style={styles.tr}>
                <td style={styles.td}>{t.registro}</td>
                <td style={{ ...styles.td, fontSize: '12px', color: '#666', maxWidth: '300px' }}>{t.documentos || '-'}</td>
                <td style={styles.td}>R$ {t.valor.toLocaleString('pt-BR')}</td>
                <td style={styles.td}>
                  <button style={styles.botaoEditar} onClick={() => editar(t)}>Editar</button>
                  <button style={styles.botaoDesativar} onClick={() => desativar(t.id)}>Desativar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  botaoNovo: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  form: { backgroundColor: '#fff', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem', border: '1px solid #e0e0e0' },
  formTitulo: { margin: '0 0 1rem', fontSize: '16px', color: '#1a1a2e' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '12px', color: '#555', marginBottom: '4px' },
  input: { padding: '9px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  formBotoes: { display: 'flex', gap: '10px', marginTop: '1rem' },
  botaoSalvar: { backgroundColor: '#1a1a2e', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  botaoCancelar: { backgroundColor: 'transparent', color: '#888', border: '1px solid #ddd', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', cursor: 'pointer' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#333' },
  botaoEditar: { backgroundColor: 'transparent', color: '#1a1a2e', border: '1px solid #ddd', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer', marginRight: '6px' },
  botaoDesativar: { backgroundColor: 'transparent', color: '#e53935', border: '1px solid #e53935', padding: '5px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' },
};